import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import EmuCalculation from "../pages/masterdatamanagement/EmuCalculation";

// Lazy loading components
const Example = lazy(() => import("../pages/example/Example"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const MasterDatamanagement = lazy(
  () => import("../pages/masterdatamanagement/MasterDataConfiguration")
);
const MapperDashboard = lazy(() => import("../pages/mapper/Mapper"));
const ApiConfiguration = lazy(() => import("../pages/apiconfig/ApiConfig"));
const EmuMasterSetup = lazy(
  () => import("../pages/masterdatamanagement/EmuMasterSetup")
);
const MapperInstructions = lazy(
  () => import("../pages/mapperinstruction/MapperInstruction")
);
const EmuGenericSetup = lazy(
  () => import("../pages/masterdatamanagement/EmuGenericSetup")
);
const BatchDataTransfer = lazy(
  () => import("../pages/batchdatatransfer/BatchDataTransfer")
);
const SuperUserAudit = lazy(() => import("../pages/hieaudit/SuperUserAudit"));
const HieAudit = lazy(() => import("../pages/hieaudit/HieAudit"));
const OrgAudit = lazy(() => import("../pages/orgaudit/OrgAudit"));
const SurveyDataUpload = lazy(
  () => import("../pages/surveydataupload/addSurvey")
);
const AddSurvey = lazy(() => import("../pages/surveydataupload/addSurvey"));
const UploadLogs = lazy(() => import("../pages/surveydataupload/uploadLogs"));
const PendingRequest = lazy(
  () => import("../pages/pendingrequest/PendingRequest")
);
const Subscribers = lazy(() => import("../pages/subscribers/Subscribers"));
const CancelledSubscriber = lazy(
  () => import("../pages/cancelledsubscriber/CancelledSubscriber")
);

// const DeactivateRequests = lazy(
//   () => import("../pages/deactivaterequests/DeactivateRequests")
// );

// const ReactivateRequests = lazy(
//   () => import("../pages/reactivaterequests/ReactivateRequests")
// );

// const DeactivateUsers = lazy(
//   () => import("../pages/deactivateusers/DeactivateUsers")
// );

const RejectedUsers = lazy(
  () => import("../pages/rejectedusers/RejectedUsers")
);
const WithdrawnUsers = lazy(
  () => import("../pages/withdrawnusers/withdrawnUsers")
);
const UserAccessManagement = lazy(
  () => import("../pages/useraccessmanagement/UserAccessManagement")
);

const OperationalDashboard = lazy(
  () => import("../pages/operationaldashboard/OperationalDashboard")
);

const DataExchange = lazy(() => import("../pages/dataexchange/DataExchange"));

const EmuFactorSetup = lazy(
  () => import("../pages/masterdatamanagement/EmuFactorSetup")
);
const ProgramTypeMaster = lazy(
  () => import("../pages/masterdatamanagement/ProgramTypeMaster")
);
const SourceTypeMaster = lazy(
  () => import("../pages/masterdatamanagement/SourceTypeMaster")
);
const ResourceTypeMaster = lazy(
  () => import("../pages/masterdatamanagement/ResourceTypeMaster")
);
const SourceSystemMaster = lazy(
  () => import("../pages/masterdatamanagement/SourceSystemMaster")
);
const ManageMasters = lazy(
  () => import("../pages/masterdatamanagement/managemasters/ManageMasters")
);

const DiseaseMaster = lazy(
  () => import("../pages/masterdatamanagement/DiseaseMaster")
);

const Constant = lazy(() => import("@pages/ruleengine/Constant"));

const Expression = lazy(() => import("@pages/ruleengine/Expression"));

const AdminProfile = lazy(() => import("@pages/profile/AdminProfile"));
const DataValidator = lazy(() => import("@pages/datavalidator/DataValidator"));

const LogoCustomization = lazy(
  () => import("../pages/settingspage/logoCustomization")
);

const HomePage = lazy(() => import("../pages/homepage/homePage"));
const Registration = lazy(
  () => import("../pages/registration/RegistrationPage")
);

const ChatbotSettings = lazy(() => import("../pages/chatbot/chatbotSettings"));

const ChatbotInterface = lazy(
  () => import("../pages/chatbot/chatbotInterface")
);

const SetPassword = lazy(() => import("../pages/setpassword/SetPassword"));
const EditRegistration = lazy(
  () => import("../pages/editregistration/EditRegistration")
);
const WithdrawRegistration = lazy(
  () => import("../pages/withdrawregistration/WithdrawRegistration")
);
const ReactivateAccount = lazy(
  () => import("../pages/reactivateaccount/ReactivateAccount")
);
const ChatbotConfig = lazy(() => import("../pages/chatbot/chatbotConfig"));
const SearchPatient = lazy(
  () => import("../pages/dataexchange/RequestDataSearch")
);

const TableMapper = lazy(() => import("@pages/ruleengine/TableMapper"));
const EmailTemplate = lazy(() => import("@pages/ruleengine/EmailTemplate"));
const ManageRules = lazy(() => import("@pages/ruleengine/ManageRules"));
const RuleResults = lazy(() => import("@pages/ruleengine/RuleResults"));
const ForgotPassword = lazy(
  () => import("@pages/forgotpassword/ForgotPassword")
); // forgot password page import
const Login = lazy(() => import("@pages/login/Login"));
const MetadataConfiguration = lazy(
  () => import("@pages/metadataconfiguration/metadataconf")
);
const UsageAnalytics = lazy(
  () => import("@pages/usageanalytics/UsageAnalytics")
);

export const routes = [
  {
    path: "/Example",
    name: "Example",
    key: "Example",
    element: <Example />,
  },
  {
    path: "/registration/:userid?",
    name: "Registration",
    key: "Registration",
    element: <Registration />,
  },
  {
    path: "/login/:istest?",//Added for SDLC testing to skip captcha
    name: "Login",
    key: "Login",
    element: <Login />,
  },
  {
    path: "/set-password/:userid?",
    name: "Set Password",
    key: "Set Password",
    element: <SetPassword />,
  },
  {
    path: "/forgotpassword",
    name: "Forgot Password",
    key: "forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/editregistration",
    name: "Edit Registration",
    key: "editregistration",
    element: <EditRegistration />,
  },
  {
    path: "/withdrawregistration/:userid?",
    name: "Withdraw Registration",
    key: "withdrawregistration",
    element: <WithdrawRegistration />,
  },
  {
    path: "/reactivateaccount/:userid?",
    name: "Reactivate Account",
    key: "reactivateaccount",
    element: <ReactivateAccount />,
  },
  {
    path: "/",
    // element: <Dashboard />,
    name: "After loggedin",
    key: "afterloggedin",
    private: true,
    exact: true,
    children: [
      {
        path: "/",
        name: "Home",
        key: "home",
        element: <HomePage />,
      },
      {
        path: "/profile",
        name: "Profile",
        key: "profile",
        element: <AdminProfile />,
      },
      {
        path: "/useraccessmanagement",
        name: "User Access Management",
        key: "useraccessmanagement",
        element: <UserAccessManagement />,
      },
      {
        path: "/operationaldashboard",
        name: "Operational Dashboard",
        key: "operationaldashboard",
        element: <OperationalDashboard />,
      },
      {
        path: "/dataexchange",
        name: "Data Exchange",
        key: "dataexchange",
        element: <DataExchange />,
      },
      {
        path: "/survey",
        name: "Survey Data Upload",
        key: "surveydataupload",
        element: <SurveyDataUpload />,
      },
      {
        path: "/chatbotsettings",
        name: "Chatbot Settings",
        key: "chatbotsettings",
        element: <ChatbotSettings />,
      },
      {
        path: "/chatbotinterface",
        name: "Chatbot Interface",
        key: "chatbotinterface",
        element: <ChatbotInterface />,
      },
      {
        path: "/survey",
        name: "Add Survey",
        key: "addsurvey",
        element: <AddSurvey />,
      },
      {
        path: "/survey/surveyuploadlogs",
        name: "Upload Logs",
        key: "surveyuploadlogs",
        element: <UploadLogs />,
      },
      {
        path: "/apiConfig",
        name: "API Config",
        key: "apiConfig",
        element: <ApiConfiguration />,
      },
      // {
      //   path: "/batchDataTransfer",
      //   name: "Batch Data Transfer",
      //   key: "batchDataTransfer",
      //   element: <BatchDataTransfer />,
      // },
      {
        path: "/batchdatatransfer",
        name: "Batch Data Transfer",
        key: "batchdatatransfer",
        element: <BatchDataTransfer />,
      },
      {
        path: "/request/pending",
        name: "Pending Request",
        key: "pendingrequest",
        element: <PendingRequest />,
      },
      {
        path: "/request/subscribers",
        name: "Subscribers",
        key: "subscribers",
        element: <Subscribers />,
      },
      {
        path: "/request/rejected",
        name: "Rejected Users",
        key: "rejected",
        element: <RejectedUsers />,
      },
      {
        path: "/request/cancelled",
        name: "Cancelled Subscriber",
        key: "cancelled",
        element: <CancelledSubscriber />,
      },
      {
        path: "/request/withdrawn",
        name: "Withdrawn Users",
        key: "withdrawn",
        element: <WithdrawnUsers />,
      },
      {
        path: "/profile",
        name: "Profile",
        key: "profile",
        element: <Dashboard />,
      },
      {
        path: "/settings",
        name: "Settings",
        key: "settings",
        element: <Example />,
      },
      {
        path: "/masterdataupload",
        name: "Master Data Upload",
        key: "masterdataupload",
        element: <MasterDatamanagement />,
      },
      {
        path: "/configuration",
        name: "Mapper",
        key: "mapdata",
        element: <MapperDashboard />,
      },
      {
        path: "/emusetup",
        name: "EMU Master Setup",
        key: "emumastersetup",
        element: <EmuMasterSetup />,
      },
      {
        path: "/emugensetup",
        name: "EMU Generic Setup",
        key: "emugensetup",
        element: <EmuGenericSetup />,
      },
      {
        path: "/superuseraudit",
        name: "SuperUserAudit",
        key: "superuseraudit",
        element: <SuperUserAudit />,
      },
      {
        path: "/hieaudit",
        name: "HieAudit",
        key: "hieaudit",
        element: <HieAudit />,
      },
      {
        path: "/orgaudit",
        name: "OrgAudit",
        key: "orgaudit",
        element: <OrgAudit />,
      },
      {
        path: "/emufactorsetup",
        name: "EMU Factors Setup",
        key: "emufactorsetup",
        element: <EmuFactorSetup />,
      },
      {
        path: "/programtype",
        name: "Program Type Master",
        key: "programtype",
        element: <ProgramTypeMaster />,
      },
      {
        path: "/sourcetype",
        name: "Source Type Master",
        key: "sourcetype",
        element: <SourceTypeMaster />,
      },
      {
        path: "/resourcetype",
        name: "Resource Type Master",
        key: "resourcetype",
        element: <ResourceTypeMaster />,
      },
      {
        path: "/sourcesystem",
        name: "Source System Master",
        key: "sourcesystem",
        element: <SourceSystemMaster />,
      },
      {
        path: "/adminprofile",
        name: "Hie Admin Profile",
        key: "admin-profile",
        element: <AdminProfile key="hie-admin-profile" />,
      },
      {
        path: "/orgprofile",
        name: "Org Admin Profile",
        key: "arg-admin-profile",
        element: <AdminProfile key="org-admin-profile" />,
      },
      {
        path: "/dataValidator",
        name: "Data Validator",
        key: "data-validator",
        element: <DataValidator />,
      },
      {
        path: "/mapperInstructions",
        name: "Mapper Instructions",
        key: "mapper-Instructions",
        element: <MapperInstructions />,
      },
      {
        path: "/logoCustomization",
        name: "Logo Customization",
        key: "logo-customization",
        element: <LogoCustomization />,
      },
      {
        path: "/tableMapper",
        name: "Table Mapper",
        key: "table-mapper",
        element: <TableMapper />,
      },
      {
        path: "/emailtemplate",
        name: "Email Template",
        key: "email-template",
        element: <EmailTemplate />,
      },
      {
        path: "/b-manage-rules",
        name: "Manage Business Rules",
        key: "b-manage-rules",
        element: <ManageRules key="manage-business-rules" type="business" />,
      },
      {
        path: "/d-manage-rules",
        name: "Manage DQ Rules",
        key: "d-manage-rules",
        element: <ManageRules key="manage-dq-rules" type="dataquality" />,
      },
      {
        path: "/ruleResults",
        name: "Business Rule Results",
        key: "rule-results",
        element: <RuleResults key="business-rule-results" type="business" />,
      },
      {
        path: "/d-rule-results",
        name: "Data Quality Rule Results",
        key: "d-rule-results",
        element: (
          <RuleResults key="data-quality-rule-results" type="dataquality" />
        ),
      },
      {
        path: "/managemasters",
        name: "Manage Masters",
        key: "managemasters",
        element: <ManageMasters />,
      },
      {
        path: "/emucalculation",
        name: "Calculations",
        key: "emucalculation",
        element: <EmuCalculation />,
      },
      {
        path: "/diseasemaster",
        name: "Disease Master",
        key: "diseasemaster",
        element: <DiseaseMaster />,
      },
      {
        path: "/constant",
        name: "Constant",
        key: "constant",
        element: <Constant />,
      },
      {
        path: "/expression",
        name: "Expression",
        key: "expression",
        element: <Expression />,
      },

      {
        path: "/chatbotconfig",
        name: "Chatbot Configuration",
        key: "chatbotconfig",
        element: <ChatbotConfig />,
      },
      {
        path: "/searchpatient",
        name: "Search Patient",
        key: "searchpatient",
        element: <SearchPatient />,
      },
      {
        path: "/metadataconf",
        name: "Metadata Configuration",
        key: "metadataconf",
        element: <MetadataConfiguration />,
      },
      {
        path: "/analytics",
        name: "Usage Analytics",
        key: "usageanalytics",
        element: <UsageAnalytics />,
      },
      // Catch-all route for unmatched paths
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  },
  // Catch-all route for unmatched paths
  {
    path: "*",
    element: <Navigate to="/login" />,
  },
];
